import React from "react";
import useRipple from "use-ripple-hook";

export default function Button({
  label = "Button",
  onClick = () => {},
  disabled = false,
  variant = "primary",
  className = "",
  width = "w-[199px]",
  height = "h-[50px]",
}) {
  const [ripple, event] = useRipple({
    disabled,
    duration: 450,
    color: "#ffffff30",
    cancelAutomatically: false,
    timingFunction: "cubic-bezier(.42,.36,.28,.88)",
  });

  const baseStyles = `
    ${width} ${height}
    rounded-[25px]
    text-[15px] font-bold
    overflow-hidden
    transition ease-in-out duration-300
    relative z-10
    flex items-center justify-center
  `;

  const variantStyles = {
    primary: `bg-transparent text-[#00B5EA] border-[3px] border-[#00B5EA]
      hover:bg-[#00B5EA] hover:text-white
    `,
    filled: `
      bg-[#004D99] text-white
      hover:bg-[#0066cc]
    `,
  };

  return (
    <button
      ref={ripple}
      onMouseDown={event}
      disabled={disabled}
      onClick={onClick}
      className={`
        ${baseStyles}
        ${variantStyles[variant]}
        ${disabled ? "opacity-60 cursor-not-allowed" : ""}
        ${className}
      `}
    >
      {label}
    </button>
  );
}
